import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {AspectRatioCard} from '@homeaway/react-aspect-ratio-card';

import LazyLoad from '../lazy-load/LazyLoad';
import {LAZY_LOAD_OFFSET} from '../../../utils/constants';
import {getValue, TESTS} from '../../../utils/abacus';
import PlaceholderImage, {PlaceholderSvg} from './Placeholder';
import {DynamicFreeCancellation} from './FreeCancellation';
import {CommonDescription, listingCaption} from './common';
import CardDescription from './CardDescription';
import ImageCardComponent from './ImageCard';
import DistanceFrom from './DistanceFrom';
import ListingBadges from './ListingBadges';

export function mapStateToProps(state) {
    const {abacus = {}, destination: {details = {}} = {}} = state;

    return {
        abacus,
        showCaptionInTwoLine:
            getValue(abacus, TESTS.OPTIMIZED_PROPERTY_CARD_CONTENT) === 1,
        expandedTripboardButton:
            getValue(abacus, TESTS.TRIPBOARDS_SAVE_LABEL) === 1,
        showFreeCancellationBadge:
            getValue(
                abacus,
                TESTS.HA_PTA_LANDING_SLP_FREE_CANCELLATION_BADGING
            ) === 1,
        simpleName: details.simpleName,
    };
}

export class GreatPlacesRatioCardComponent extends PureComponent {
    handleTripboardClick = (evt) => {
        evt.preventDefault();
    };

    renderCarouselDescription({caption, subcaption}) {
        const {
            instantBookable,
            link,
            price,
            review,
            breadcrumbs,
            distanceFrom,
            badges,
            tripleId,
            showFreeCancellationBadge,
        } = this.props;

        return (
            <div
                key={'content'}
                data-slot={'content'}
                className={'GreatPlaceRatioCard__footer margin-top'}
            >
                {this.renderTripboard()}
                <a href={link}>
                    {caption}
                    <CardDescription text={breadcrumbs} />
                    {subcaption && (
                        <CardDescription
                            text={subcaption}
                            className="CommonRatioCard__subcaption"
                        />
                    )}
                    {distanceFrom && <DistanceFrom text={distanceFrom} />}
                    {badges && badges.length && (
                        <ListingBadges items={badges} />
                    )}
                    <CommonDescription
                        instantBookable={instantBookable}
                        price={price}
                        review={review}
                    />
                    {showFreeCancellationBadge && (
                        <DynamicFreeCancellation tripleId={tripleId} />
                    )}
                </a>
            </div>
        );
    }

    renderInnerCard({
        caption,
        currentIndex,
        images,
        offset,
        placeholder,
        position,
        subcaption,
    }) {
        const imgProps = {
            currentIndex,
            position,
            images,
        };

        return [
            <div
                key={'figure'}
                data-slot={'figure'}
                className={'GreatPlaceRatioCard__img-container'}
            >
                <LazyLoad offset={offset} placeholder={placeholder}>
                    {imgProps.images[0] === '' ? (
                        <PlaceholderSvg />
                    ) : (
                        <ImageCardComponent {...imgProps} />
                    )}
                </LazyLoad>
            </div>,
            this.renderCarouselDescription({caption, subcaption}),
        ];
    }

    renderCard({offset, placeholder, caption, subcaption}) {
        const {
            aspectRatio = '4x3',
            currentIndex,
            images = [],
            position,
        } = this.props;

        return (
            <AspectRatioCard
                aspectRatio={aspectRatio}
                key={currentIndex}
                hasHover={false}
            >
                {this.renderInnerCard({
                    caption,
                    currentIndex,
                    images,
                    offset,
                    placeholder,
                    position,
                    subcaption,
                })}
            </AspectRatioCard>
        );
    }

    renderTripboard() {
        const {
            actionLocation,
            tripleId,
            expandedTripboardButton,
            images = [],
            propertyName,
            review: {averageRating, reviewCount},
            simpleName,
            tripboardComponent: TripboardComponent,
        } = this.props;

        return (
            TripboardComponent && (
                <TripboardComponent
                    actionlocation={actionLocation}
                    listingId={tripleId}
                    expandedButton={expandedTripboardButton}
                    headline={propertyName}
                    newBoardName={simpleName}
                    onClick={this.handleTripboardClick}
                    averageRating={averageRating}
                    reviewCount={reviewCount}
                    thumbnailUrl={images[0]}
                />
            )
        );
    }

    render() {
        const {
            showCaptionInTwoLine,
            highlighted,
            isMobile,
            key,
            onClick,
            onMouseOut,
            onMouseOver,
            propertyName,
            toplineDescription: subcaption,
        } = this.props;

        const className = highlighted
            ? 'GreatPlaceRatioCard GreatPlaceRatioCard--highlighted'
            : 'GreatPlaceRatioCard';

        const placeholder = <PlaceholderImage />;

        const caption = listingCaption({
            toplineDescription: propertyName,
            textTwoLine: showCaptionInTwoLine,
        });

        const offset = LAZY_LOAD_OFFSET[isMobile ? 'MOBILE' : 'DEFAULT'];

        return (
            <div
                key={key}
                role="button"
                onClick={onClick}
                className={className}
                onMouseOver={onMouseOver}
                onMouseOut={onMouseOut}
            >
                {this.renderCard({
                    className,
                    placeholder,
                    caption,
                    subcaption,
                    offset,
                })}
            </div>
        );
    }
}

export const GreatPlacesRatioCard = connect(mapStateToProps)(
    GreatPlacesRatioCardComponent
);

GreatPlacesRatioCard.displayName = 'GreatPlacesRatioCard';

export default GreatPlacesRatioCard;
